module.exports = __webpack_public_path__ + "files/dc415840cbd2e46db0d7be6eda38233a.png";